export const buildConsumerSettlement = (settlement: string) => {
  const settlementArray = settlement.split(' ');

  if (settlementArray.length === 1) {
    return settlementArray[0];
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [type, ...settlementParts] = settlementArray;

  return settlementParts.join(' ');
};
